import { useQuery, useMutation, useQueryClient } from 'react-query';
import { clearUserLink, getUserLinks, updateUserLink } from '../../api/admin/adminLinks';
import useAuthStore from '../../store/authStore';

export const useLinks = () => {
  const queryClient = useQueryClient();
  const { user } = useAuthStore();

  const { data, isLoading, error } = useQuery(
    'links',
    getUserLinks,
    {
      enabled: !!user,
      onError: (error) => {
        console.error('Failed to fetch links:', error);
      }
    }
  );

  const updateLinkMutation = useMutation(updateUserLink, {
    onSuccess: () => {
      queryClient.invalidateQueries('links');
    },
    onError: (error) => {
      console.error('Failed to update link:', error);
    }
  });

  const clearLinkMutation = useMutation(clearUserLink, {
    onSuccess: () => {
      queryClient.invalidateQueries('links');
    },
    onError: (error) => {
      console.error('Failed to clear link:', error);
    }
  });

  return {
    links: data,
    isLoading,
    error: error?.response?.data?.message || error?.message,
    updateLink: updateLinkMutation.mutate,
    clearLink: clearLinkMutation.mutate
  };
};